<template>
    <div class="column is-full">
        <div class="card-content">
            <h2 class="has-text-centered has-text-weight-semibold is-size-4">{{sectionTitle}}</h2>
            <b-field :label="fieldLabel">
                <b-datetimepicker
                v-if="order.orderdata.shipmentMethod == 'retiro'"
                inline
                placeholder="Click para seleccionar"
                icon="calendar-today"
                :disabled="true"
                locale="es-ES"
                v-model="parsedDate">
                </b-datetimepicker>

                <b-datepicker
                v-if="order.orderdata.shipmentMethod == 'delivery'"
                inline
                :disabled="true"
                placeholder="Click para seleccionar"
                icon="calendar-today"
                locale="es-ES"
                v-model="parsedDate">
                </b-datepicker>

            </b-field>
            <p class="has-text-weight-semibold" v-if="order.orderdata.shipmentMethod == 'delivery'">
                <span v-if="timeString == 8"> De 08 a 13 hrs.</span>
                <span v-if="timeString == 13"> De 13 a 19 hrs.</span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        order:{
            type: Object,
            default: new Object({})
        }
    },
    computed:{
        parsedDate(){
            var dateString = this.order.orderdata.deliveryDate.split("T")[0]
            
            var timeString = this.order.orderdata.deliveryDate.split("T")[1].split("Z")[0]
            console.log(dateString)
            var hora = timeString.split(":")[0]
            if(hora[0] == '0'){
                hora = parseInt(hora[1])
            }else{
                hora = parseInt(hora)
            }
            var parsedDate = new Date(this.order.orderdata.deliveryDate)
            console.log(parsedDate)
            parsedDate.setHours(hora)
            return parsedDate
        },
        timeString(){
            var timeString = this.order.orderdata.deliveryDate.split("T")[1].split("Z")[0]
            var hora = timeString.split(":")[0]
            if(hora[0] == '0'){
                hora = parseInt(hora[1])
            }else{
                hora = parseInt(hora) - 3
            }
            return hora
        },
        fieldLabel(){
            var txt = this.order.orderdata.shipmentMethod == 'retiro' ? 'Fecha y hora de retiro seleccionada' : 'Fecha de entrega seleccionada'
            return txt
        },
        sectionTitle(){
            var txt = this.order.orderdata.shipmentMethod == 'retiro' ? 'Informacion de retiro' : 'Informacion de entrega'
            return txt
        }
    },
}
</script>